export const simpleEventsSectionMessageEn = {
  // Cohort Builder - Simple Events Content
  'projects.cohortBuilder.simpleEventsSection.title': 'Simple events',
  'projects.cohortBuilder.simpleEventsSection.buttonLabel': 'Simple event',
  'projects.cohortBuilder.simpleEventsSection.eventItemLabel': 'Event',
  'projects.cohortBuilder.simpleEventsSection.typeItemLabel': 'Type',
  'projects.cohortBuilder.simpleEventsSection.noSimpleEventsMainMsg': 'No simple events',
  'projects.cohortBuilder.simpleEventsSection.noSimpleEventsSubMsg':
    'Define a simple event to get started',

  // Cohort Builder - Simple Events Edit Modal
  'projects.cohortBuilderPage.simpleEventsEditModal.editMode.title': 'Edit simple event',
  'projects.cohortBuilderPage.simpleEventsEditModal.createMode.title': 'Create simple event',
  'projects.cohortBuilderPage.simpleEventsEditModal.viewMode.title': 'View simple event',
  'projects.cohortBuilderPage.simpleEventsEditModal.uniquenessFilterRestrictionTitle':
    'Only one uniqueness filter can be applied to a simple event.',

  // Cohort Builder - Simple Events Edit Modal - Filter Buttons
  'projects.cohortBuilderPage.simpleEventsEditModal.filterButtons.conceptFilter': 'Concept filter',
  'projects.cohortBuilderPage.simpleEventsEditModal.filterButtons.numericFilter': 'Numeric filter',
  'projects.cohortBuilderPage.simpleEventsEditModal.filterButtons.relatedEntityFilter':
    'Related entity filter',
  'projects.cohortBuilderPage.simpleEventsEditModal.filterButtons.uniquenessFilter':
    'Uniqueness filter',
  'projects.cohortBuilderPage.simpleEventEditCard.cancelButtonText': 'Close',

  // Cohort Builder - Events error messages
  'projects.cohortBuilderPage.inputFieldError': 'No {field} selected.',
  'projects.cohortBuilderPage.inputFieldError.conceptGroupFieldError': 'concept group',
  'projects.cohortBuilderPage.inputFieldError.eventFieldError': 'event',

  // Cohort Builder - Simple Events Delete Modal
  'projects.cohortBuilderPage.simpleEventsDeleteModal.title': 'Delete simple event',
  'projects.cohortBuilderPage.simpleEventsDeleteModal.submittingTitle': 'Deleting simple event',
};
